import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2, X } from 'lucide-react';
import api from '../../api/client';

// Avviso a schermo per chi gestisce il calendario (26/10/2026): un destinatario di un link condiviso ha
// toccato "Ho visto". Ogni minuto guarda le ultime conferme; resta finché non lo chiudi o lo tocchi.
// Il segno "fin qui già avvisato" sta nel browser per utente: alla primissima apertura non mostra il passato.
export default function AvvisoCalendario({ attivo, utente }) {
  const [nuovi, setNuovi] = useState([]);
  const nav = useNavigate();
  useEffect(() => {
    if (!attivo || !utente) return;
    const chiave = `calendario_avviso_ultimo_${utente}`;
    let vivo = true;
    const controlla = () => api.get('/calendario/avvisi').then(r => {
      if (!vivo) return;
      const lista = r.data || [];
      const max = lista.reduce((m, x) => Math.max(m, x.id), 0);
      let ultimo = null;
      try { ultimo = localStorage.getItem(chiave); } catch {}
      if (ultimo === null) { try { localStorage.setItem(chiave, String(max)); } catch {} return; }
      const arrivati = lista.filter(x => x.id > +ultimo);
      if (!arrivati.length) return;
      try { localStorage.setItem(chiave, String(max)); } catch {}
      setNuovi(p => [...arrivati, ...p.filter(x => !arrivati.some(a => a.id === x.id))].slice(0, 5));
    }).catch(() => {});
    controlla();
    const t = setInterval(controlla, 60000);
    return () => { vivo = false; clearInterval(t); };
  }, [attivo, utente]);
  if (!nuovi.length) return null;
  const ora = (d) => new Date(d).toLocaleString('it-IT', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
  return (
    <div role="status" style={s.box} onClick={() => { setNuovi([]); nav('/calendario?scheda=link'); }}>
      <CheckCircle2 size={20} color="#1F7A45" style={{ flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 800 }}>Calendario visto</div>
        {nuovi.map(x => (
          <div key={x.id} style={{ fontSize: '13px', color: 'var(--text-muted)' }}>
            <b style={{ color: 'var(--text)' }}>{x.nome}</b> · {x.link?.nome} · {x.modifiche ? `${x.modifiche} ${x.modifiche === 1 ? 'modifica vista' : 'modifiche viste'}` : 'nessuna modifica'} · {ora(x.created_at)}
          </div>
        ))}
        <div style={{ fontSize: '12px', color: 'var(--text-dim)' }}>tocca per aprire i link condivisi</div>
      </div>
      <button style={s.x} onClick={e => { e.stopPropagation(); setNuovi([]); }} aria-label="Chiudi"><X size={16} /></button>
    </div>
  );
}
const s = {
  box: { display: 'flex', gap: '12px', alignItems: 'center', width: 'min(360px, calc(100vw - 32px))', background: 'var(--bg-card)', color: 'var(--text)', border: '1px solid var(--border)', borderLeft: '4px solid #1F7A45', borderRadius: '14px', padding: '12px 14px', boxShadow: '0 12px 32px rgba(0,0,0,.18)', cursor: 'pointer', pointerEvents: 'auto' },
  x: { border: 'none', background: 'none', cursor: 'pointer', color: 'var(--text-dim)', padding: '4px', display: 'flex' },
};
